import React from "react";
import { StaticQuery, graphql } from "gatsby";

import Article from './Article';

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allWordpressPost {
          edges {
            node {
              categories {
                name
              }
              slug
              title
              id
              content
            }
          }
        }
      }
    `}
    render={data => (
      <ul className="master-class-list">
        {
            data.allWordpressPost.edges.map(item => {
              let article_item = item.node;
              // eslint-disable-next-line
              if (props.filter === '') {
                  return(
                      // <LazyLoad key={index} height={1000} once offset={100}>
                          <Article key={article_item.id} slug={article_item.slug} id={article_item.id} title={article_item.title} content={article_item.content} category={article_item.categories} />
                      // </LazyLoad>
                  )
                  // eslint-disable-next-line
              } else if (article_item.categories[0].name === props.filter) {
                  return(
                      // <LazyLoad key={index} height={1000} once offset={100}>
                          <Article key={article_item.id} slug={article_item.slug} id={article_item.id} title={article_item.title} content={article_item.content} category={article_item.categories} />
                      // </LazyLoad>
                  )
              } else {
                  return null
              }
            })
        }
      </ul>
    )}
  />
)